// ============================================================================
// Entity: ColorDefinitions
// Key: colorDefinitions
// Kind: entity
// Generated file. Do not edit manually.
// ============================================================================

import {
	getColorDefinitionsListQueryKey,
	getColorDefinitionsListQueryOptions,
} from '../api/backstage'
// #region Imports
import type { ColorDefinitionDto } from '../api/backstage.schemas'
import type { EntityConfig } from './entity-config.types'
import { defineQueryEndpoint } from './entity-config.types'

// #endregion

// #region Entity Endpoints
const colorDefinitionsEntityEndpoints = {
	list: defineQueryEndpoint<ColorDefinitionDto[], undefined, undefined>({
		key: 'colorDefinitions.list',
		method: 'GET',
		path: '/admin/colordefinitions',
		queryKey: (_args) => getColorDefinitionsListQueryKey(),
		queryOptions: (_args) => getColorDefinitionsListQueryOptions(),
	}),
} as const
// #endregion

// #region Entity Config Export
export const colorDefinitionsEntityConfig = {
	key: 'colorDefinitions',
	kind: 'entity',
	entity: {
		idField: 'id',
		routePath: '/colorDefinitions',
	},
	endpoints: colorDefinitionsEntityEndpoints,
} as const satisfies EntityConfig<'colorDefinitions'>
// #endregion
